import { createContext } from 'react';

type AppContextType = {
  refresh: boolean;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  refreshTime: number;
  setRefreshTime: React.Dispatch<React.SetStateAction<number>>;
};

export const AppContext = createContext<AppContextType>({
  refresh: false,
  setRefresh: () => {}, // default no-op
  refreshTime: 0,
  setRefreshTime: () => {},
});
